import { useMemo, useState } from 'react'
import { Option } from './Option'

const blankIfNotString = (value: unknown): string => {
  return typeof value === 'string' ? value : ''
}

export const useFormSelectInput = (options: Option[]): [Option[], (value: string) => void] => {
  const [inputValue, setInputValue] = useState('')
  const filteredOptions = useMemo(
    () =>
      options.filter((option) =>
        blankIfNotString(option.label).toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
      ),
    [inputValue, options]
  )
  return [filteredOptions, setInputValue]
}
